import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

/**
 * Modal component (stub).
 * Props: open, onClose, children
 */
export default function Modal({ open, onClose, children }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-2xl shadow-strong p-6 max-w-sm w-full relative">
        {children || <div className="text-center">Modal content</div>}
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-2"
          aria-label="Close"
          onClick={onClose}
          style={{ fontSize: 32, lineHeight: 1, width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
}

/**
 * LimitEventModal: Generic modal for all limit/auto-withdrawal events.
 * Props:
 * - open: boolean
 * - onClose: function
 * - title: string
 * - message: string
 * - affectedAction: string (e.g., 'Deposit', 'Play')
 * - iconType: 'lock' | undefined
 * - children: ReactNode (footer)
 */
export function LimitEventModal({ open, onClose, title, message, affectedAction, iconType, children }) {
  const { t } = useTranslation();
  if (!open) return null;
  const LockIcon = (
    <svg className="w-8 h-8 text-gray-500 mb-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="8" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
  );
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" role="dialog" aria-modal="true">
      <div className="bg-white rounded-2xl shadow-strong p-6 max-w-sm w-full relative flex flex-col items-center">
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-2"
          aria-label="Close"
          onClick={onClose}
          style={{ fontSize: 32, lineHeight: 1, width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        {iconType === 'lock' && LockIcon}
        <h2 className="text-2xl font-bold mb-2 text-center text-heading text-hc-black">{title}</h2>
        <div className="text-gray-700 text-center mb-4">{message}</div>
        <button
          className="btn btn-primary w-full mt-2"
          onClick={onClose}
        >
          {t('common.back_to_simulation')}
        </button>
        {children && <div className="mt-4 w-full text-xs text-gray-500 text-center">{children}</div>}
      </div>
    </div>
  );
} 